import React from 'react';
import './MarketStats.css';

const MarketStats = ({ stats }) => {
  // Use actual pool amount if available, otherwise fall back to prediction costs
  const totalCoins = stats.totalPoolAmount || ((stats.totalPredictions || 0) * 7);

  // Calculate activity rate (predictions per game)
  const activityRate = stats.totalGames > 0
    ? (stats.totalPredictions / stats.totalGames).toFixed(1)
    : '0.0';

  // Format large numbers with K suffix
  const formatNumber = (num) => {
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toString();
  };

  const statCards = [
    {
      label: 'CURRENTLY TRACKED',
      value: stats.totalGames || 0,
      suffix: ' games',
      color: 'neutral'
    },
    {
      label: 'QUICKPICK AIX ENTRYS',
      value: formatNumber(stats.totalPredictions || 0),
      suffix: '',
      color: 'neutral'
    },
    {
      label: 'TOTAL DAILY POOL VOLUME',
      value: formatNumber(totalCoins),
      suffix: '',
      color: 'gold'
    },
    {
      label: 'HEAT',
      value: activityRate,
      suffix: ' avg',
      color: parseFloat(activityRate) > 2 ? 'hot' : 'neutral'
    }
  ];

  return (
    <div className="market-stats financial compact">
      {statCards.map((stat, index) => (
        <div key={index} className={`market-stat-card ${stat.color}`}>
          <div className="stat-label">{stat.label}</div>
          <div className="stat-value-row">
            <span className="stat-value">
              {stat.value}
              {stat.suffix && <span className="stat-suffix">{stat.suffix}</span>}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MarketStats;